// extracted by css-extract-rspack-plugin
export default {"fields":"fields-exhMgi","row":"row-xMQbRM","endRow":"endRow-AdY0Wp","bareSwitch":"bareSwitch-MvBw5X"};